







































import Vue from 'vue';
import StormImage from '@/components/StormImage.vue';
import TextInformation from '@/components/TextInformation.vue';

export default Vue.extend({
  name: 'InformationSection',
  components: {
    StormImage,
    TextInformation,
  },
});
